import { render, staticRenderFns } from "./ClosingActions.vue?vue&type=template&id=0967ae8b"
import script from "./ClosingActions.vue?vue&type=script&lang=js"
export * from "./ClosingActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports